import RightNode from './RightNode'
import { toFixed } from "@/utils/Wire.js"
import errorMessages from '@/utils/ErrorMessages.js'

export default class DCDCBooster extends RightNode {
  constructor() {
    super()
  }

  getChildCandidates () {
    return ["switchPanel", "pressurePump", "fridge", "usb", "light", "heater", "carSocket"] 
  }

  getBaseVoltage () {
    return this.model?.data.spannung_out
  }

  getErrorMessages () {
    const result = []

    // if more than one child exists, each of them must have the same "spannung". It is not allowed 
    // to mix up the voltage
    //
    if ( this.children.length > 1 ) {
      // all direct children must have the same voltage
      //
      const firstSpannung = this.children[0].calculateConsumptionData().spannung
      if ( this.children.find( child => child.calculateConsumptionData().spannung !== firstSpannung) ) {
        result.push({ 
          type: "Error", 
          text: errorMessages.t('mixedVoltagesNotAllowed', {
            component: 'DC-DC converter'
          })
        })
      }
    }

    // In case one parent is a fuse, it must have a lower "ampere" than this device.
    // If not, this device is burned before the fuse can protect the circuit
    //
    /*
    const amp = this.getFuseAmp()
    if ( amp === undefined || amp > this.model.data.strom_in ) {
      result.push({ 
        type: "Error", 
        text: errorMessages.t('dcdcConverterBreaksBeforeFuse', {
          converterCurrent: this.model.data.strom_in,
          fuseCurrent: amp
        })
      })
    }
    */

    // Calculate if the accumulated "strom"
    //
    if ( this.children.length > 0 ) {
      const data = this.children[0].calculateConsumptionData()
      // skip the first element, because we have already the data of the first element in charge
      // ( slice(1) )
      this.children.slice(1).forEach( child => {
        data.strom += child.calculateConsumptionData().strom 
      })
      // the "leerlaufspannung" must be smaller than the max input of the charger
      //
      if ( data.strom > this.model.data.strom ) {
        result.push({ 
          type: "Error", 
          text: errorMessages.t('currentTooHigh', {
            component: 'DC-DC converter',
            actual: toFixed(data.strom),
            max: this.model.data.strom
          })
        })
      }
    }

    if ( this.parent ) {
      // Spannungen müssen passen
      const base = this.parent.getBaseVoltage()
      if ( this.model.data.spannung_in !== base) {
        result.push({ 
          type: "Error", 
          text: errorMessages.t('voltageNotSupported', {
            component: 'DC-DC converter',
            required: this.model.data.spannung_in,
            actual: base
          })
        })
      }
    }
 
    return result
  }

  calculateOutputData () {
    const data = super.calculateOutputData()
    // required for the wire calculation and the parents needs this two attributes for the 
    // overall current/watt calculation
    data.strom = data.strom_in
    data.spannung = data.spannung_in

    return data
  }

  calculateConsumptionData () {
    const result = { strom: 0, spannung: this.model.data.spannung_in, watt: 0, amperestunden: 0 }
    if ( this.children.length > 0 ) {
      // check that the attributes "strom" and "spannung" are in place
      result.strom = this.children[0].calculateConsumptionData().strom
      result.amperestunden = this.children[0].calculateConsumptionData().amperestunden
      this.children.slice(1).forEach( child => {
        result.strom += child.calculateConsumptionData().strom 
        result.amperestunden += child.calculateConsumptionData().amperestunden 
      })
    }
    // Umrechnen von der Ausgangsspannung zu der Eingangsspannung. Da ändert sich der Strom
    //
    if ( this.model.data.spannung_in && this.model.data.spannung_in !== 0 ) {
      result.strom = toFixed( (result.strom * this.model.data.spannung_out ) / this.model.data.spannung_in )
      result.amperestunden = toFixed( (result.amperestunden * this.model.data.spannung_out ) / this.model.data.spannung_in )
    } else {
      result.strom = NaN
      result.amperestunden = NaN
    }
    
    result.watt = (result.strom * result.spannung)

    return result
  }
}
